export const LOAD_MAP_COOKIE = 'sah-load-map';
export const LOAD_MAP_COOKIE_VALUE = '1';

export const getStaticMapUrl = ({ lat, lng, zoom = 11, apiKey }) =>
  `https://maps.googleapis.com/maps/api/staticmap?center=${lat},${lng}&scale=2&zoom=${zoom}&format=png&maptype=roadmap&size=1500x1400&key=${apiKey}`;

export default {
  getStaticMapUrl,
  LOAD_MAP_COOKIE
};
